
import './App.css';
import Caluclator from './Component/Caluclator';


function App() {
  return (
    <div className="App">
      <Caluclator/>
    </div>
  );
}

export default App;
